import { motion } from "framer-motion";

/** 3D風に回転する桜コインアイコン */
export function SakuraCoinIcon({ size = 24, className = "" }: { size?: number; className?: string }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center select-none ${className}`}
      style={{ width: size, height: size, perspective: 400 }}
    >
      <motion.div
        animate={{
          rotateY: [0, 360],
        }}
        transition={{
          repeat: Infinity,
          repeatDelay: 2.5,
          duration: 1.8,
          ease: "easeInOut",
        }}
        className="relative w-full h-full rounded-full flex items-center justify-center shadow-md overflow-hidden"
        style={{
          background: "linear-gradient(135deg, #ffd1dc 0%, #ff85a2 50%, #f43f5e 100%)",
          border: "1.5px solid #fff",
          boxShadow: "0 2px 6px rgba(244, 63, 94, 0.4)",
        }}
      >
        {/* 桜の花マーク */}
        <span style={{ fontSize: size * 0.55 }} className="leading-none drop-shadow-sm">
          🌸
        </span>
        {/* キラリと走る光沢シャイン */}
        <motion.div
          animate={{
            x: ["-100%", "200%"],
          }}
          transition={{
            repeat: Infinity,
            repeatDelay: 3.2,
            duration: 0.8,
            ease: "easeOut",
          }}
          className="absolute inset-0 w-1/2 h-full bg-gradient-to-r from-transparent via-white/60 to-transparent skew-x-12 pointer-events-none"
        />
      </motion.div>
    </div>
  );
}

/** ゆらゆら燃えるストリーク炎アイコン */
export function StreakFireIcon({ size = 24, className = "" }: { size?: number; className?: string }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center select-none ${className}`}
      style={{ width: size, height: size }}
    >
      {/* 炎のゆらぎアニメーション */}
      <motion.div
        animate={{
          scale: [1, 1.12, 0.96, 1.08, 1],
          rotate: [-3, 3, -2, 2, 0],
        }}
        transition={{
          repeat: Infinity,
          duration: 1.2,
          ease: "easeInOut",
        }}
        className="flex items-center justify-center"
        style={{ fontSize: size * 0.85 }}
      >
        🔥
      </motion.div>
      {/* 飛び散る小さな火の粉 */}
      <motion.div
        animate={{
          y: [0, -size * 0.6],
          x: [0, 4, -4],
          opacity: [0, 1, 0],
          scale: [0.6, 1, 0.2],
        }}
        transition={{
          repeat: Infinity,
          duration: 1.4,
          ease: "easeOut",
        }}
        className="absolute top-0 right-1 w-1.5 h-1.5 rounded-full bg-amber-300 pointer-events-none shadow-[0_0_4px_#f59e0b]"
      />
    </div>
  );
}

/** ドキドキ拍動するライフハートアイコン */
export function HeartPulseIcon({ size = 24, className = "" }: { size?: number; className?: string }) {
  return (
    <motion.div
      animate={{
        scale: [1, 1.22, 1, 1.15, 1],
      }}
      transition={{
        repeat: Infinity,
        repeatDelay: 1.2,
        duration: 0.8,
        times: [0, 0.2, 0.4, 0.6, 1],
        ease: "easeInOut",
      }}
      className={`inline-flex items-center justify-center select-none ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.8 }}
    >
      ❤️
    </motion.div>
  );
}

/** キラキラ輝くXPスターアイコン */
export function SparkleStarIcon({ size = 24, className = "" }: { size?: number; className?: string }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center select-none ${className}`}
      style={{ width: size, height: size }}
    >
      <motion.div
        animate={{
          scale: [1, 1.18, 1],
          rotate: [0, 15, -15, 0],
        }}
        transition={{
          repeat: Infinity,
          duration: 2.2,
          ease: "easeInOut",
        }}
        style={{ fontSize: size * 0.85 }}
      >
        ⭐
      </motion.div>
      {/* キラキラ粒子 */}
      <motion.div
        animate={{
          scale: [0, 1, 0],
          rotate: [0, 90],
          opacity: [0, 1, 0],
        }}
        transition={{
          repeat: Infinity,
          repeatDelay: 1.5,
          duration: 1.0,
          ease: "easeOut",
        }}
        className="absolute -top-1 -right-1 text-yellow-300 pointer-events-none"
        style={{ fontSize: size * 0.45 }}
      >
        ✨
      </motion.div>
    </div>
  );
}
